export function currentLocationIs($url) {
    const location = window.location;
    return !location.pathname || location.pathname === $url;
}
